import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { AppContext } from '@prisjakt/ui-app-context';
import Button from '@prisjakt/ui-button';
import Breadcrumb from '@prisjakt/ui-breadcrumb';

import TrackingSettingCheckbox from './components/tracking-setting';
import PageHeader from '../../components/page-header';
import PageContent from '../../components/page-content';
import actions from './actions/tracking';
import './sagas/tracking';
import * as S from './styles';

const BEHAVIOR_TRACKING_IMPROVEMENT = 'behavior_tracking_improvement';
const PERSONALIZATION = 'personalization';

const TrackingSettings = props => {
  const { t } = useContext(AppContext);
  return (
    <S.TrackingSettings>
      <PageContent>
        <Breadcrumb
          homeText={t('common', 'breadcrumb.home')}
          path={[
            {
              id: '1',
              name: t('tracking-settings', 'page.title'),
              pathName: '',
            },
          ]}
        />
        <PageHeader title={t('tracking-settings', 'page.title')} />
        {Object.keys(props.settings)
          .filter(item => item !== PERSONALIZATION)
          .map(item => (
            <React.Fragment key={item}>
              <TrackingSettingCheckbox
                title={t('tracking-settings', `${item}.title`)}
                name={item}
                handleChange={name => {
                  props.trackingToggleChange(name, !props.settings[name]);
                }}
                text={t('tracking-settings', `${item}.text`)}
                checked={props.settings[item]}
              />
              {item === BEHAVIOR_TRACKING_IMPROVEMENT && (
                <TrackingSettingCheckbox
                  title={t('tracking-settings', `${PERSONALIZATION}.title`)}
                  name={PERSONALIZATION}
                  handleChange={name => {
                    props.trackingToggleChange(name, !props.settings[name]);
                  }}
                  text={t('tracking-settings', `${PERSONALIZATION}.text`)}
                  checked={props.settings[PERSONALIZATION]}
                  disabled={!props.settings[BEHAVIOR_TRACKING_IMPROVEMENT]}
                  indent
                />
              )}
            </React.Fragment>
          ))}
        <Button
          color="positive"
          variant="outlined"
          onClick={() => {
            props.trackingToggleSave(props.settings, props.isAuthenticated);
          }}
        >
          {t('common', 'button.save')}
        </Button>
        {props.hasError && 'An error occurred while saving your preferences'}
      </PageContent>
    </S.TrackingSettings>
  );
};

TrackingSettings.propTypes = {
  settings: PropTypes.shape({
    ads: PropTypes.number,
    surveys: PropTypes.number,
    productImprovement: PropTypes.number,
    marketing: PropTypes.number,
  }),
  isAuthenticated: PropTypes.bool,
  trackingToggleChange: PropTypes.func,
  trackingToggleSave: PropTypes.func,
  hasError: PropTypes.bool,
};

TrackingSettings.defaultProps = {
  settings: PropTypes.shape({
    ads: 1,
    surveys: 1,
    productImprovement: 1,
    marketing: 0,
  }),
  isAuthenticated: false,
  trackingToggleChange: () => {},
  trackingToggleSave: () => {},
  hasError: false,
};

export default connect(
  state => ({
    ...state.areas.account,
    ...state.areas.user.tracking,
  }),
  actions
)(memo(TrackingSettings));
